import axios from 'axios';
import CryptoJS from "crypto-js";

const SECRET_KEY = ')H@MccQffTjWnZr4u7x!A%CF*F-JaNdRgUkUkUXNh*F-JaNDOCTALL';

export const doEncryption = async (data) => {
    try {
        var test_id_array = await CryptoJS.AES.decrypt(data.toString().replaceAll("doctall", "/"), SECRET_KEY)
        let parcedDecryption = JSON.parse(test_id_array.toString(CryptoJS.enc.Utf8))
        return parcedDecryption
    } catch (error) {
        console.log(error)
    }

}

export const getRecommendedTest = async (testId, areaId) => {

    let payLoad = {
        tests: testId,
        area: areaId
    }

    let response = await axios.post(`${process.env.REACT_APP_API_URL}/labtest/diagnostic/recomended/test`, payLoad)
    if (response && response.status === 200 || response.status === 201) {
        return response;
    }
    throw new Error("Failed to get Record");
}


export const getCities = async () => {
    let response = await axios.get(`${process.env.REACT_APP_API_URL}/uploadDoc/allcities`)
    if (response && response.status === 200 || response.status === 201) {
        return response;
    }
    throw new Error("Failed to get Record");
}


export const getPartners = async () => {
    let response = await axios.get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
    if (response && response.status === 200 || response.status === 201) {
        return response;
    }
    throw new Error("Failed to get Record");
}